import router from "./index.js"
import store from "@/store"
import {Message} from 'element-ui'
router.beforeEach((to,from,next)=>{
    if(to.matched.some(res=>res.meta.isLogin)){

        if ( store.state.user.isLogin || localStorage.getItem('isLogin') ) {
            next();
        }else{
            if( from.name == 'faceCollection' ){
                Message({
                    message: '请先上传人脸采集',
                    type: 'error',
                    duration: 2000,
                    offset: 40
                  })
                return false;
            }
            next({
                path:"/",
                // query:{
                //     redirect:to.fullPath
                // }
            });
        }

        //补学教育和我的课程用同一个页面 需要刷新
        if( to.name != 'videoLearning' ){
            if( from.name == 'myCourseCopy' || from.name == 'myCourse' ){
                window.location.reload();
            }
        }
        
    }else{
        next()
    }
});

export default router;


// WEBPACK FOOTER //
// ./src/router/permission.js